import dynamic from 'next/dynamic';

import { useProductCoupon } from '@/domains/loyalty/components/Coupon/hooks/useProductCoupon/useProductCoupon';
import type { Coupon } from '@/domains/productDiscovery/ProductPage/interfaces/Detail.common.model';

const DynamicCoupon = dynamic(() =>
  import('@/domains/loyalty/components/Coupon/Coupon').then(
    (mod) => mod.Coupon,
  ),
);

const DynamicCouponNoCode = dynamic(() =>
  import('@/domains/loyalty/components/Coupon/CouponNoCode').then(
    (mod) => mod.CouponNoCode,
  ),
);

interface ProductCouponProps {
  context: string;
  productId: number;
  quantity: number;
  unitPrice: number;
  coupons?: Coupon | Coupon[];
  forceDisableTooltip?: boolean;
}

export const ProductCoupon: React.FC<ProductCouponProps> = ({
  context,
  productId,
  quantity,
  unitPrice,
  coupons,
  forceDisableTooltip = false,
}) => {
  // eslint-disable-next-line no-nested-ternary
  const actualCoupons = coupons
    ? Array.isArray(coupons)
      ? coupons
      : [coupons]
    : undefined;

  const { coupon, type } = useProductCoupon(
    context,
    productId,
    quantity,
    unitPrice,
    actualCoupons,
  );

  if (type === 'no-coupon' || !coupon) {
    return null;
  }

  if (type === 'simple') {
    return <DynamicCoupon {...coupon} context={context} />;
  }

  return (
    <DynamicCouponNoCode
      amount={coupon.discountValue}
      context={context}
      forceDisableTooltip={forceDisableTooltip}
    />
  );
};
